'use strict';

import EnquiryForm from '../js/theme/EnquiryForm';
import Utils from '../js/theme/Utils';

// waits which of the promises returns first, if it takes too long there will be no form on the site
const isEnquiryFormLoaded = () => {
    const waitTime = 5 * 1000; // 5s
    return Promise.race([
        new Promise((_, reject) => setTimeout(() => reject(), waitTime)),
        new Promise((resolve) => {
            const isLoaded = () => {
                const selectBox = document.querySelector('#nf-field-5');
                return !Utils.isUndefined(selectBox) ? resolve() : setTimeout(isLoaded, 200);
            };

            isLoaded();
        }),
    ]);
};

const main = () => {
    const FORM_PAGE_SLUG_DE = 'urlaubsanfrage';
    const FORM_PAGE_SLUG_EN = 'booking-trip-enquiry';

    if (!Utils.isPage(FORM_PAGE_SLUG_DE) && !Utils.isPage(FORM_PAGE_SLUG_EN)) {
        return;
    }

    isEnquiryFormLoaded()
        .then(() => {
            new EnquiryForm();
        })
        .catch(() => {
            // console.info('Form not available');
        });
};

window.addEventListener('DOMContentLoaded', main);
